import { CreateMerchantTxn } from '@/api/queryHooks/useMerchantCryptoController';

export const checkoutTypes = {
  QR_CODE: 'QR_CODE' as CreateMerchantTxn['mode'],
  WALLET_CONNECT: 'WALLET_CONNECT' as CreateMerchantTxn['mode'],
};
